import { Button, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ReactNode } from 'react'

interface IStoreCardProps {
  logo: ReactNode
  name: string
  onClick: (vaue: string) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: '20rem',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    borderRadius: '0.5rem !important',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '1.5rem',
    gap: '1rem',

    '& h1': {
      color: '#191C1A',
      textAlign: 'left',
      fontFamily: 'Sora',
      fontSize: '1.25rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '2rem',
      margin: 0,
    },

    '& figure': {
      margin: 0,
      padding: 0,
    },
  },

  btn: {
    width: '100%',
    padding: '0.5rem',
    textAlign: 'center',
    height: '2.625rem',
  },
}))

const StoreCard = ({ logo, name, onClick }: IStoreCardProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <figure>{logo}</figure>
      <h1>{name}</h1>
      <Button
        variant='contained'
        className={classes.btn}
        onClick={() => onClick(name)}
      >
        Solicitar informações
      </Button>
    </div>
  )
}

export default StoreCard
